import { default as index8w8T3TYZXUMeta } from "/var/www/pages/[lang]/index.vue?macro=true";
import { default as uaXzHPReJwcNMeta } from "/var/www/pages/[lang]/ua.vue?macro=true";
import { default as indexTNebhwOASsMeta } from "/var/www/pages/index.vue?macro=true";
import { default as healthzUJyHLXiUK6Meta } from "/var/www/pages/manage/healthz.vue?macro=true";
import { default as privacy_45policy9QsFv2Ub0jMeta } from "/var/www/pages/privacy-policy.vue?macro=true";
import { default as terms_45of_45service3Njsq0OFjHMeta } from "/var/www/pages/terms-of-service.vue?macro=true";
export default [
  {
    name: index8w8T3TYZXUMeta?.name ?? "lang",
    path: index8w8T3TYZXUMeta?.path ?? "/:lang()",
    meta: index8w8T3TYZXUMeta || {},
    alias: index8w8T3TYZXUMeta?.alias || [],
    redirect: index8w8T3TYZXUMeta?.redirect,
    component: () => import("/var/www/pages/[lang]/index.vue").then(m => m.default || m)
  },
  {
    name: uaXzHPReJwcNMeta?.name ?? "lang-ua",
    path: uaXzHPReJwcNMeta?.path ?? "/:lang()/ua",
    meta: uaXzHPReJwcNMeta || {},
    alias: uaXzHPReJwcNMeta?.alias || [],
    redirect: uaXzHPReJwcNMeta?.redirect,
    component: () => import("/var/www/pages/[lang]/ua.vue").then(m => m.default || m)
  },
  {
    name: indexTNebhwOASsMeta?.name ?? "index",
    path: indexTNebhwOASsMeta?.path ?? "/",
    meta: indexTNebhwOASsMeta || {},
    alias: indexTNebhwOASsMeta?.alias || [],
    redirect: indexTNebhwOASsMeta?.redirect,
    component: () => import("/var/www/pages/index.vue").then(m => m.default || m)
  },
  {
    name: healthzUJyHLXiUK6Meta?.name ?? "manage-healthz",
    path: healthzUJyHLXiUK6Meta?.path ?? "/manage/healthz",
    meta: healthzUJyHLXiUK6Meta || {},
    alias: healthzUJyHLXiUK6Meta?.alias || [],
    redirect: healthzUJyHLXiUK6Meta?.redirect,
    component: () => import("/var/www/pages/manage/healthz.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policy9QsFv2Ub0jMeta?.name ?? "privacy-policy",
    path: privacy_45policy9QsFv2Ub0jMeta?.path ?? "/privacy-policy",
    meta: privacy_45policy9QsFv2Ub0jMeta || {},
    alias: privacy_45policy9QsFv2Ub0jMeta?.alias || [],
    redirect: privacy_45policy9QsFv2Ub0jMeta?.redirect,
    component: () => import("/var/www/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: terms_45of_45service3Njsq0OFjHMeta?.name ?? "terms-of-service",
    path: terms_45of_45service3Njsq0OFjHMeta?.path ?? "/terms-of-service",
    meta: terms_45of_45service3Njsq0OFjHMeta || {},
    alias: terms_45of_45service3Njsq0OFjHMeta?.alias || [],
    redirect: terms_45of_45service3Njsq0OFjHMeta?.redirect,
    component: () => import("/var/www/pages/terms-of-service.vue").then(m => m.default || m)
  }
]